import Question from "../../assets/images/question.svg";
import parse from "html-react-parser";
import {ActionButton} from "../ActionButton/ActionButton";

export const columnsEmailTable = (isAdmin,isDelivery) => {
    let analysisItems = [];
    isDelivery = isDelivery === 2;
    // console.log("isDelivery",isDelivery);
    analysisItems.push(
        {accessorKey: "DT_RowId", header: "#", cell: ({getValue}) =>
                <div style={{padding: "0px 15px"}}>{getValue()}
                </div>},
        {
            accessorKey: "sender",
            header: "Sender",
            cell: ({getValue}) => {
                return (
                    <div className="row3">
                        <small>{getValue()}</small>
                    </div>
                )
            },
        },
        {
            accessorKey: "email_Subject",
            header: "Subject",
            cell: ({getValue}) => {
                const value = getValue()?getValue():"";
                return (
                    <div className="row3">
                        <small>{value}</small>
                    </div>
                )
            },
        },
        {
            accessorKey: "total_sent",
            header: "Email Recipients",
            cell: ({getValue}) => {
                const total = getValue();
                return (
                    <div className="row1" style={{color: total.cls}}>
                        {total.text}
                    </div>
                )
            },
        });
    if(isAdmin){
        analysisItems.push(
            {
                accessorKey: "email_Content",
                header: "Content",
                cell: ({getValue}) => {
                    return (
                        <div className="row1">
                            <small>{parse(getValue())}</small>
                        </div>
                    )
                },
            });
    }
    if(!isDelivery) {
        analysisItems.push(
            {
                accessorKey: "email_type",
                header: "Email Type",
                cell: ({getValue}) => {
                    const status = getValue();
                    return (
                        <div className="row1" style={{color: status['cls']}}>
                            {status['text']}
                        </div>
                    )
                },
            });
    }
    analysisItems.push( {
                accessorKey: "status",
                header: "Status",
                cell: ({getValue}) => {
                    const status = getValue();
                    return (
                        <div className="row1" style={{color: status['cls']}}>
                            {status['text']}
                        </div>
                    )
                },
            },
            {
                accessorKey: "created_at",
                header: "Date",
                cell: ({getValue}) => {
                    const date = getValue();
                    return (
                        <div className="row1">
                            {date}
                        </div>
                    )
                },
            });

    if(isDelivery) {
        analysisItems.push({
                accessorKey: "action",
                header: "Action",
                cell: ({getValue}) => {
                    const action = getValue();
                    return (
                        <div className="row3 analy-btn" style={{paddingRight: "10px"}}>
                            {action === 0 && (
                                <>
                                    <ActionButton title="Resolved" mode="1"
                                                  className="resolve-btn" id={action}/>
                                    <ActionButton title="Remove"
                                                  className="remove-btn" mode="2" id={action}/>
                                </>
                            )}
                        </div>
                    );
                },
            }
        );
    }
    // console.log(analysisItems);
    return analysisItems;
}
